"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderPlacedRo = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.OrderPlacedRo = typebox_1.Type.Object({
    first_name: typebox_1.Type.Optional(typebox_1.Type.String()),
    delivery_guarantee: typebox_1.Type.Optional(typebox_1.Type.String()),
});
//# sourceMappingURL=order-placed-ro.js.map